    // src/lib/notice.js
    const API_BASE = '/api';

    // 공통 fetch
    async function http(path, options = {}) {
    const res = await fetch(`${API_BASE}${path}`, {
        credentials: 'include',
        headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
        ...options,
    });
    if (!res.ok) {
        const text = await res.text().catch(() => '');
        throw new Error(`HTTP ${res.status} ${res.statusText} ${text}`);
    }
    const ct = res.headers.get('content-type') || '';
    return ct.includes('application/json') ? res.json() : null;
    }

    // 목록
    export async function fetchNotices({ size = 1000 } = {}) {
    const data = await http(`/notices?size=${size}`);
    const arr = Array.isArray(data) ? data : (data?.content || []);
    return arr.map(mapNotice);
    }

    // 상세
    export async function fetchNoticeDetail(id) {
    return http(`/notices/${id}`);
    }

    // 첨부 파일 목록
    export async function fetchNoticeFiles(noticeId) {
    const list = await http(`/notices/${noticeId}/files`);
    return (Array.isArray(list) ? list : []).map((f) => ({
        id: f.id,
        originalName: f.originalName || f.filename || f.name || `file-${f.id}`,
        contentType: f.contentType || 'application/octet-stream',
        size: Number.isFinite(f.size) ? f.size : 0,
    }));
    }

    // 다운로드 링크
    export function fileDownloadUrl(fileId) {
    return `/api/files/${fileId}/download`;  // ✅ 백엔드 경로와 일치
    }

    // 매핑
    function mapNotice(it) {
    const dateRaw = it.createdAt || it.created_at || it.createdDate || it.date;
    return {
        id: it.id,
        type: String(it.type || 'NOTICE').toUpperCase(),
        title: it.title ?? '(제목 없음)',
        hasFile: !!it.hasFile,
        date: dateRaw ? String(dateRaw).slice(0, 10) : '',
        _raw: it,
    };
    }
